<mat-card>




    <mat-card-content>
<div >
        <div
        style="background: url('../../assets/img/morceau/titre.png');height: 60px; background-size: 100% 100%; width: 100%;color: #2F4395; font-size: 18px;">

        <div style="float: left;margin-top:5px;">
            <img src="../../assets/img/morceau/2.png" height="40">
            Contact Principal
        </div>
        <div style="float: right; cursor: pointer;" (click)="clickedMe()">
            <img src="../../assets/img/morceau/edit.png">
        </div>

    </div>

    <div style=" background: #F9F9F9;">

        <div  class="titles1">
            <div class="label">
                Nom
            </div>

            <div class="label">
                Position
            </div>

            <div class="label">
                Mobile
            </div>

            <div class="label">
                Telephone
            </div>

       

            <div class="label">
                      E-Mail
            </div>

             
        </div>




 
        <div class="content1" *ngIf="selectedContact">
 
            <div class="labeltext">
                {{selectedContact.nom}}
            </div>

            <div class="labeltext">  {{selectedContact.titres}}
 
               

            </div>

            <div class="labeltext">
                {{selectedContact.mobile}}
            </div>
            <div class="labeltext">
                {{selectedContact.tel}}
            </div>
            <div class="labeltext">
                {{selectedContact.mail}}
            </div>

        </div>






    </div>

</div>
  

    </mat-card-content>






 
</mat-card>